import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';
import { deleteActivity } from './api';
import { QueryKey } from '@behavior/QueryKey';
import { useHistory } from 'react-router';

function useDeleteActivity(activityId: number) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const history = useHistory();

  const { mutate, isLoading } = useMutation(() => deleteActivity(activityId), {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKey.ACTIVITY_VIEW);
      history.push('/activity/activityOverview');
      toast.success(t('message.title.success.delete.activity'));
    },
    onError: () => {
      toast.error(t('message.title.error.delete.activity'));
    },
  });
  return { deleteActivityMutate: mutate, isLoadingDeleteActivity: isLoading };
}
export default useDeleteActivity;
